import { combineReducers } from 'redux';
import usageList from './UsageList/reducer';
import createEditUsage from './CreateEditUsage/reducer';

export default combineReducers({
  usageList,
  createEditUsage,
});



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/usage/state/reducers.js